import { Component, computed, signal } from "@angular/core";
import { ZoomControlService } from "../../../_services/zoom-control.service";

@Component({
  selector: "app-zoom-control",
  templateUrl: "./zoom-control.component.html",
  styleUrl: "./zoom-control.component.scss",
  standalone: true
})
export class ZoomControlComponent {
  constructor(public zoomControlService: ZoomControlService) {}

  zoomRatio = computed(() => {
    const zoomFactor = this.zoomControlService.zoomFactor();
    return (zoomFactor * 100).toFixed(0);
  });

  resetZoom() {
    this.zoomControlService.resetZoom();
  }

  zoomIn() {
    this.zoomControlService.zoomIn();
  }

  zoomOut() {
    this.zoomControlService.zoomOut();
  }
}
